import React from "react";
import Common from "./Common";
import img from "../../images/komal2.png";
// import Contact from "../Contact/Contact";
// import Service from "../Project/Service";
// import Education from "../Education/Education";
// import Achievement from "../Achievement/Achievement";
// import Skills from "../Skills/Skills";
// import Experience from "../Experience/Exp";
import { about } from "../../portfolio.js";
function Home() {
  console.log(new Date().getFullYear());
  return (
    <div>
      <Common
        name="Home Page"
        imgsrc={img}
        visit="https://drive.google.com/file/d/1xaRVp3Ltu2-CX4kRQRNYI0AVOUKp0GBG/view?usp=share_link"
        btname="Download Resume"
        about={about.about_data}
      />

      {/* <Education />
      <Skills />
      <Experience />
      <Service />
      <Achievement />
      <Contact /> */}
    </div>
  );
}

export default Home;
